<template>
  <div class="basic_wrap">
    <div
      class="back_left"
      @click="kefu_to"
    >
      <img
        src="../img/user/kf.png"
        style="width:30px;height: 30px ;border-radius: 50%;"
      >
    </div>
		
    <div
      class="language"
      @click="$router.push('/language')"
    >
      <img :src="language_logo">
    </div>
    <div class="logo">
      <img :src="config.logo">
    </div>
    <div class="form_div">
      <form
        class="form"
        @submit.prevent="submit"
      >
        <div
          v-if="!config.register_phone"
          class="item"
        >
          <input
            v-model.trim="data.username"
            type="text"
            class="inp"
            :placeholder="$t('login.username')"
          >
        </div>
        <div
          v-if="config.register_phone"
          class="item"
        >
          <input
            v-model.trim="data.username"
            type="number"
            class="inp"
            :placeholder="$t('login.phone')"
          >
        </div>
        <div class="item">
          <input
            v-model.trim="data.password"
            :type="password"
            class="inp"
            :placeholder="$t('login.password')"
          >
          <div
            class="eye_bi"
            :class="password == 'text' ? 'eye' : ''"
            @click="showPwd"
          />
        </div>
        <div class="item">
          <input
            v-model.trim="data.code"
            type="text"
            class="inp"
            :placeholder="$t('login.code')"
          >
          <img
            style="height: 40px;border-radius: 12px;"
            :src="verify_img"
            @click="getVerifyCode()"
          >
        </div>
        <div style="width: 100%; height: 24px; margin-top: 0; line-height: 24px; text-align: center; margin-bottom: 10px;">
          <div style="float: left; margin-left: 5px;">
            <router-link to="/register">
              <div style="color: #000; font-weight: 700; font-size: 14px;">
                {{ $t('login.registerNow') }}
              </div>
            </router-link>
          </div>
          <div style="float: right; margin-right: 15px;">
            <router-link to="/pwd">
              <div style="color: red; font-weight: 700; font-size: 14px;">
                {{ $t('utils.lunlog36') }}?
              </div>
            </router-link>
          </div>
        </div>
        <button
          type="button"
          style="position: relative; width: 100%; height: 50px; border-radius: 12px; border: none; color: #fff; font-size: 18px; font-weight: 700; letter-spacing: .4px; background: #e50914; box-shadow: none;"
          @click="submit"
        >
          {{ $t('login.loginNow') }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Dialog);

export default {
		name: "Login",
		data() {
			return {
				language_logo: localStorage.getItem('language_logo'),
				password: "password",
				loading: false,
				data: {
					username: "",
					password: "",
					code: "",
				},
				config: {
					register_phone: 1
				},
				verify_img: "",
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FAFAFA');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer("user", false);
		},

		mounted() {
			this.start();
			this.getVerifyCode();
		},
		methods: {
			start() {
				Fetch("/index/getWebInfo").then((r) => {
					this.config = r.data;
				});
			},
			kefu_to() {
				window.location.href = this.config.kefu;
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			submit() {
				if (this.loading) {
					return false;
				}
				//数字、字母或下划线
				var reg1 = /^[0-9a-zA-Z_]{1,}$/;
				//非手机号注册判断
				if (!this.config.register_phone) {
					if (!this.data.username) {
						this.$toast(this.$t('login.usernameEmpty'));
						return false;
					}
					if (!reg1.test(this.data.username)) {
						this.$toast(this.$t('login.usernameLimit'));
						return false;
					}
					if (this.data.username.length > 16 || this.data.username.length < 4) {
						this.$toast(this.$t('login.usernameLength'));
						return false;
					}
				}
				//手机号注册判断
				else {
					if (!this.data.username) {
						this.$toast(this.$t('auth.phoneEmpty'));
						return false;
					}
					if (this.data.username.length < 6 || this.data.username.length > 16) {
						this.$toast(this.$t('auth.phoneError'));
						return;
					}
				}
				
				if (!this.data.password) {
					this.$toast(this.$t('login.passwordEmpty'));
					return false;
				}
				if (!reg1.test(this.data.password)) {
					this.$toast(this.$t('login.passwordLimit'));
					return false;
				}
				if (this.data.password.length > 16 || this.data.password.length < 6) {
					this.$toast(this.$t('login.passwordLength'));
					return false;
				}
				if (!this.data.code) {
					this.$toast(this.$t('login.codeEmpty'));
					return false;
				}
				this.loading = true;
				Fetch("/index/login", {
					...this.data,
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
						// 更新 store 中的用户登录状态
						this.$store.commit('setLogin', { token: res.data.token });
					}
					this.$toast(this.$t('login.loginSuccess'));
					this.$router.replace("/");
				}).catch((res) => {
					this.getVerifyCode();
					this.loading = false;
				});
			},
			getVerifyCode() {
				Fetch("/index/captcha").then((r) => {
					this.verify_img = r.data.image;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.basic_wrap{
		position: relative;
		overflow: hidden;
		min-height: 100vh;
		padding: 0 18px 24px;
		background-color: var(--bg-primary);
		color: var(--text-primary);

	}
	.form_div {
		// height: 600px;
		width: 100%;
		// background: url(../img/user/login_background.png) no-repeat center center;
		// background-size: 150% 100%;
		// position: relative;
		// top: -108px;

		.form {
			position: absolute;
			margin-top: 30px;
			padding: 18px 14px 16px;
			border: 1px solid rgba(176, 202, 240, .55);
			    border-radius: 18px;
			    box-shadow: 0 18px 34px rgba(24, 61, 122, .12), inset 0 1px 0 hsla(0, 0%, 100%, .9);
			background: linear-gradient(155deg, hsla(0, 0%, 100%, .96), rgba(246, 250, 255, .94) 55%, rgba(236, 246, 255, .9));
			width: 90%;

			.register_btn {
				background: #68326C;
				color: #FFFFFF;
				width: 60px;
				height: 60px;
				border-radius: 50%;
				float: right;
				margin-right: 3%;
				text-align: center;
				line-height: 60px;
				font-size: 36px;
				font-weight: bold;
			}
		}
	}

	.back_left {
		background: unset;

		img {
			width: 20px;
			position: fixed;
			top: 10px;
			left: 10px;
		}
	}

	.language {
		position: absolute;
		top: 6px;
		right: 6px;
		height: 30px;
		z-index: 11;

		img {
			height: 100%;
		}
	}

	.logo {
		margin: 8px 2px 8px;
		    padding: 16px 14px 6px;
		    text-align: center;

		img {
			height: 80px;
			display: inline-flex;
			border-radius: 15px;
			margin: 0 auto;
		}
	}

	.item {
		height: 40px;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		padding-bottom: 4px;
		margin-bottom: 15px;
		border-radius: 12px;
		padding: 0 0px 0px 15px;
		background: rgba(248, 252, 255, .95);
		border: 1px solid #d8e6fb;
		transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
		
		input {
			height: 40px;
			flex: 1;
			color: #1a2742;
			&::placeholder {
				color: #000;
			}
		}

		.get_captcha {
			line-height: 40px;
		}

		.eye_bi {
			margin-bottom: 12px;
		}
	}

	.sms_verify {
		padding: 20px 20px 0 20px;

		input {
			margin-top: 15px;
			height: 20px;
			font-size: 16px;
			width: 100%;
			
		}

		.btn {
			margin-top: 15px;
			justify-content: space-around;
			color: #ee0a24;
			height: 48px;
			font-size: 16px;
			border-top: 1px solid #ebedf0;

			div {
				width: 50%;
				text-align: center;
			}

			div:nth-child(1) {
				border-right: 1px solid #ebedf0;
			}
		}
	}

	.login_register {
		position: relative;
		top: -60px;
		font-size: 14px;
		margin-left: 50px;
	}
	
	/deep/ .van-dropdown-menu__bar {
		background-color: unset;
		box-shadow: unset;
		height: 50px;
		margin-right: 10px;
	}

	/deep/ .van-popup--top {
		left: 5%;
		width: 30%;
	}
</style>
